import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,LoadingController } from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';

/**
 * Generated class for the RaisedservicehistoryPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-raisedservicehistory',
  templateUrl: 'raisedservicehistory.html',
})
export class RaisedservicehistoryPage {
 historyData :any = []
  constructor(private loadingCtrl:LoadingController,
    public navCtrl: NavController, public navParams: NavParams,public cp:CommonProvider) {
  }
 toggleDetails(data) {
    if (data.showDetails) {
      data.showDetails = false;
      data.icon = 'ios-arrow-down';
    } else {
      data.showDetails = true;
      data.icon = 'ios-arrow-up';
    }
  }
  ionViewDidLoad() {
    let loading = this.loadingCtrl.create({
            content: 'Please wait...'
          });
    loading.present()
    this.cp.getSrHistory(loading,'CC02','404276').then((res:any)=>{
      loading.dismiss()
      var res=JSON.parse(res)
      this.historyData  = res.Payload.serviceRequestHistory;
      this.historyData.forEach((res:any)=>{
        res.showDetails=false;
        res.icon='ios-arrow-down'
      })
      // console.log(res.Payload.serviceRequestHistory)
    })
  }


}



// WEBPACK FOOTER //
// ./src/pages/raisedservicehistory/raisedservicehistory.ts